<template>
    <van-cell-group>
        <van-field v-model="baseInfo.vehicleCode" label="车辆编号" required readonly />
        <van-field v-model="baseInfo.barCode" label="条码编号" required readonly />
        <van-field v-model="baseInfo.category" label="车辆类别" required readonly />
        <van-field v-model="baseInfo.model" label="车辆型号" required readonly />
        <van-field v-model="baseInfo.brand" label="品牌" required readonly />
        <van-field v-model="baseInfo.entryTime" label="入场日期" required readonly />
        <van-field v-model="baseInfo.customer" label="客户名称" required readonly />
        <!-- <van-field v-model="baseInfo.phone" label="电话" required readonly /> -->
        <van-field v-model="baseInfo.owner" label="权责人" required readonly />
        <!-- <van-field v-model="baseInfo.driver" label="驾驶员姓名" required readonly />
        <van-field v-model="baseInfo.driverPhone" label="驾驶员电话" required readonly /> -->
        <van-field v-if="parentType === 'quality'" v-model="driverNamePhones" label="驾驶员"
            type="textarea" readonly />
        <van-field
            v-else
            v-model="driverNamePhones"
            :clearable="true"
            :readonly="isReadOnly"
            icon="question-o"
            autosize
            type="textarea"
            label="驾驶员"
            :border="true"
            placeholder="输入驾驶员"
            @click="clickDrivers" />
        <van-popup
            v-model="showDrivers"
            :style="{ height: '30%' }"
            position="bottom">
            <van-checkbox-group v-model="checkedDrivers">
                <van-cell-group>
                    <van-cell
                        v-for="(item,index) in driversColumn"
                        :key="item.id"
                        clickable
                        :title="`${item.name+'-'+item.contactNo}`"
                        @click="toggle(item,index)">
                        <van-checkbox slot="right-icon" ref="checkboxes" shape="square" :name="item.id" />
                    </van-cell>
                </van-cell-group>
            </van-checkbox-group>
        </van-popup>
    </van-cell-group>
</template>

<script>
import { getDriverList } from '@/api/basics'
import { Toast } from 'vant'
export default {
    name: 'MaintainInfo',
    props: {
        baseInfo: {
            type: Object,
            default: null
        },
        parentType: {
            type: String,
            default: ''
        },
        isReadOnly: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            showDrivers: false,
            driversColumn: [],
            checkedDrivers: [],
            driverNamePhones: '',
            driverParam: {
                customerId: this.baseInfo.customerId,
                PageIndex: 0,
                PageSize: 1000
            }
        }
    },
    created() {
        this.initDriverData()
        this.getDrivers()
    },
    methods: {
        clickDrivers() {
            if (this.isReadOnly) {
                this.showDrivers = false
            } else {
                this.showDrivers = true
            }
        },
        initDriverData() {
            this.driverNamePhones = this.baseInfo.drivers.join(',')
        },
        getDrivers() {
            getDriverList(this.driverParam).then((resdriver) => {
                if (resdriver.code == 200) {
                    this.driversColumn = resdriver.data.pagerData
                    var i = 0
                    for (i; i < this.driversColumn.length; i++) {
                        this.driversColumn[i].checked = false
                    }
                }
            })
        },
        toggle(item, index) {
            // var j = 0
            // var count = 0
            // for (j; j < this.driversColumn.length; j++) {
            //     if (this.driversColumn[j].checked == true) {
            //         count++
            //     }
            // }
            if (item.checked == true) {
                item.checked = false
                this.$refs.checkboxes[index].toggle(false)
            } else {
                item.checked = true
                this.$refs.checkboxes[index].toggle(true)
            }
            this.onDriversConfirm()
            // if (this.baseInfo.drivers && this.baseInfo.drivers.length > 2) {
            //     Toast.fail('最多绑定两个驾驶员')
            //     this.isReadOnly = false
            //     return
            //     // item.checked = false
            //     // this.$refs.checkboxes[index].toggle(false)
            //     // return
            // }
        },
        onDriversConfirm() {
            var j = 0
            this.driverNamePhones = ''
            this.baseInfo.driver = ''
            this.baseInfo.driverPhone = ''
            this.baseInfo.drivers = []
            for (j; j < this.driversColumn.length; j++) {
                if (this.driversColumn[j].checked == false) {
                    continue
                }
                this.driverNamePhones += this.driversColumn[j].name + '-' + this.driversColumn[j].contactNo + ','
                this.baseInfo.driver += this.driversColumn[j].name + ','
                this.baseInfo.driverPhone += this.driversColumn[j].contactNo + ','
                // this.baseInfo.drivers[j] = this.driversColumn[j].name + '-' + this.driversColumn[j].contactNo
                this.baseInfo.drivers.push(this.driversColumn[j].name + '-' + this.driversColumn[j].contactNo)
            }
            if (this.driverNamePhones.length > 0) {
                this.driverNamePhones = this.driverNamePhones.substring(0, this.driverNamePhones.length - 1)
            }

            if (this.baseInfo.driver.length > 0) {
                this.baseInfo.driver = this.baseInfo.driver.substring(0, this.baseInfo.driver.length - 1)
            }

            if (this.baseInfo.driverPhone.length > 0) {
                this.baseInfo.driverPhone = this.baseInfo.driverPhone.substring(0, this.baseInfo.driverPhone.length - 1)
            }
            // this.baseInfo.drivers = this.baseInfo.drivers.filter(item => { return item })
            console.log('驾驶员', this.baseInfo.drivers)
        }
    }
}
</script>
